// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { Component } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { FrontendSettings } from '../../../helpers/FrontendSettings'
import { FrontendSettingsKeys } from '../../../types/enums'
import './TextFieldFilterFormatter.scss'

interface ITextFieldFilterFormatterProps extends WithTranslation {
  resetPage?: () => void
  onChange?: (value: string) => void
  numericRegex?: RegExp
  isNumeric?: boolean
  initialValue?: string
}

interface ITextFieldFilterFormatterState {
  value: string
  debounceTimeout: number
  showLoader: boolean
}

class TextFieldFilterFormatter extends Component<ITextFieldFilterFormatterProps, ITextFieldFilterFormatterState> {
  constructor(props: ITextFieldFilterFormatterProps) {
    super(props)

    this.state = {
      value: props.initialValue || '',
      debounceTimeout: null,
      showLoader: false,
    }
  }
  componentDidUpdate(
    prevProps: Readonly<ITextFieldFilterFormatterProps>,
    prevState: Readonly<ITextFieldFilterFormatterState>,
    snapshot?: any
  ): void {
    if (this.props.initialValue !== prevProps.initialValue) {
      this.setState({ value: this.props.initialValue })
    }
  }

  render() {
    const { t } = this.props
    const { value } = this.state
    return (
      <div className="rdg-filter-container">
        <div className="input-area">
          <input
            tabIndex={0}
            type="text"
            placeholder=" "
            className="rdg-filter transparent"
            name={`fieldnameveryunique${new Date().getTime()}`}
            autoComplete="none"
            list="autocompleteOff"
            value={value || ''}
            onChange={(e) => this.onChangeEvent(e)}
            onKeyDown={(e) => this.onKeyDownEvent(e)}
          />
          <button
            title={t('CLEAR')}
            className="clr-btn"
            onClick={() => {
              this.onChange('')
            }}
          >
            <span className="icon-clear" />
          </button>
          {this.state.showLoader ? <div className="loader"></div> : null}
        </div>
      </div>
    )
  }

  private onKeyDownEvent(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Enter') {
      this.onChangeEvent(e as any, true)
    }
  }

  private onChangeEvent(e: React.ChangeEvent<HTMLInputElement>, instant?: boolean) {
    const { isNumeric, numericRegex } = this.props
    this.setState({ showLoader: true })
    this.resePage()
    const val = e.target.value
    if (isNumeric && numericRegex && val && !numericRegex.test(val)) {
      return
    }
    this.onChange(val, instant)
  }

  private onChange(value: string, instant?: boolean) {
    FrontendSettings.clear(FrontendSettingsKeys.modelFilterState)
    this.setState({
      value,
    })

    this.sendDebouncedValueChange(value && value.length > 0 && !instant)
  }

  private resePage() {
    if (this.props.resetPage) {
      this.props.resetPage()
    }
  }

  private sendDebouncedValueChange(useDelay: boolean) {
    if (this.state.debounceTimeout) {
      clearTimeout(this.state.debounceTimeout)
    }
    const debounceTimeout = window.setTimeout(
      () => {
        this.props.onChange(this.state.value)
        this.setState({ showLoader: false })
      },
      useDelay ? 700 : 0
    )

    this.setState({
      debounceTimeout,
    })
  }
}

export default withTranslation('common')(TextFieldFilterFormatter)
